<ion-app>
  <ion-router-outlet></ion-router-outlet>

  <p class="version">
    v {{ appVersion }}
  </p>
</ion-app>
 